<template>
  <div>
    <v-dialog v-model="dialogData" width="800" persistent>
      <v-card>
        <v-card-title>
          {{ formTitle }}
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-container>
              <v-row style="align-items: center">
                <v-col cols="10" sm="3"> Fee Name </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="8">
                  <v-text-field
                    id="fee_name"
                    ref="fee_name"
                    v-model="editedItemData.fee_name"
                    @change="$v.editedItemData.fee_name.$touch()"
                    @blur="$v.editedItemData.fee_name.$touch()"
                    :error-messages="feeNameErrors"
                  />
                </v-col>
              </v-row>
              <v-row style="align-items: center">
                <v-col cols="10" sm="3"> Sales Volume/month </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="3" sm="3">
                  <v-text-field
                    id="volume_month_min"
                    ref="volume_month_min"
                    v-model="editedItemData.volume_month_min"
                    @change="$v.editedItemData.volume_month_min.$touch()"
                    @blur="$v.editedItemData.volume_month_min.$touch()"
                    :error-messages="volumeMonthMinErrors"
                    prefix="Rp"
                  />
                </v-col>
                <v-col cols="3" sm="3" v-if="showMax">
                  <v-text-field
                    id="volume_month_max"
                    ref="volume_month_max"
                    v-model="editedItemData.volume_month_max"
                    @change="$v.editedItemData.volume_month_max.$touch()"
                    @blur="$v.editedItemData.volume_month_max.$touch()"
                    :error-messages="volumeMonthMaxErrors"
                    prefix="Rp"
                  />
                </v-col>

                <v-col cols="2">
                  <v-switch
                    v-model="editedItemData.volume_status"
                    label="infinity"
                    color="orange"
                    @change="$v.editedItemData.volume_status.$touch()"
                    @blur="$v.editedItemData.volume_status.$touch()"
                    :error-messages="volumeStatusErrors"
                  />
                </v-col>
              </v-row>

              <v-row style="align-items: center">
                <v-col cols="10" sm="3"> Fee Sharing </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="8">
                  <v-text-field
                    id="fee_sharing"
                    ref="fee_sharing"
                    v-model="editedItemData.fee_sharing"
                    @change="$v.editedItemData.fee_sharing.$touch()"
                    @blur="$v.editedItemData.fee_sharing.$touch()"
                    :error-messages="feeSharingErrors"
                    suffix="%"
                  />
                </v-col>
              </v-row>

              <v-row style="align-items: center">
                <v-col cols="10" sm="3"> Mulai Berlaku </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="8">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="editedItemData.started_date_val"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editedItemData.started_date_val"
                        label="Picker in menu"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        @change="$v.editedItemData.started_date_val.$touch()"
                        @blur="$v.editedItemData.started_date_val.$touch()"
                        :error-messages="startedDateValErrors"
                      />
                    </template>
                    <v-date-picker
                      v-model="editedItemData.started_date_val"
                      type="month"
                      no-title
                      scrollable
                      :min="dateToday"
                    >
                      <v-spacer />
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="
                          $refs.menu.save(editedItemData.started_date_val)
                        "
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn dark color="red" @click="cancelDialog"> Cancel </v-btn>
          <v-btn
            color="primary"
            @click="save"
            :disabled="loading"
            :loading="loading"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, numeric } from 'vuelidate/lib/validators';
import {
  isEmpty,
  date,
  showAlert,
  regexNumericDecimalOne,
} from '../../lib/helpers';

export default {
  props: {
    editedItem: {
      type: Object,
      default: null,
    },
    dialogFee: {
      type: Boolean,
      default: false,
    },
    editedIndex: {
      type: Number,
      default: null,
    },
  },
  mixins: [validationMixin],
  validations: {
    editedItemData: {
      fee_name: {
        required,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.fee_name == null ||
              this.errorValidation.fee_name.length < 1)
          );
        },
      },
      volume_month_min: {
        required,
        numeric,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.volume_month_min == null ||
              this.errorValidation.volume_month_min.length < 1)
          );
        },
      },
      volume_month_max: {
        required() {
          if (!this.editedItemData.volume_status) {
            return this.editedItemData.volume_month_max != '';
          }
          return true;
        },
        numeric,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.volume_month_max == null ||
              this.errorValidation.volume_month_max.length < 1)
          );
        },
      },
      fee_sharing: {
        required,
        numericDecimal: regexNumericDecimalOne,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.fee_sharing == null ||
              this.errorValidation.fee_sharing.length < 1)
          );
        },
      },
      started_date_val: {
        required,
      },
      volume_status: {
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.volume_status == null ||
              this.errorValidation.volume_status.length < 1)
          );
        },
      },
    },
  },
  data: () => ({
    dialog: false,
    dateToday: new Date().toISOString().slice(0, 7),
    menu: false,
  }),
  computed: {
    editedItemData: {
      get() {
        return this.editedItem;
      },
      set(newValue) {
        this.$emit('update:editedItem', newValue);
      },
    },
    dialogData() {
      return this.dialogFee;
    },
    formTitle() {
      return this.editedIndex != -1
        ? 'Edit Setting SPE Fee'
        : 'Add Setting SPE Fee';
    },
    flashErrorMessage() {
      const errorData = this.errorValidation.message
        ? this.errorValidation.message
        : this.$store.state.settingFee.settingSpeFee.flashErrorMessage;
      return errorData;
    },

    flashError: {
      get() {
        return this.$store.state.settingFee.settingSpeFee.flashError;
      },
      set() {
        this.$store.commit('settingFee/settingSpeFee/setFlashErrorMessage', '');
      },
    },
    errorValidation() {
      return this.$store.state.settingFee.settingSpeFee.errors;
    },
    loading() {
      return this.$store.state.settingFee.settingSpeFee.loading;
    },
    feeNameErrors() {
      const errors = [];
      if (!this.$v.editedItemData.fee_name.$dirty) return errors;
      if (!this.$v.editedItemData.fee_name.required) {
        errors.push('This field is required');
      }
      if (!this.$v.editedItemData.fee_name.isUnique) {
        if (this.errorValidation.fee_name != null) {
          this.errorValidation.fee_name.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    volumeMonthMinErrors() {
      const errors = [];
      if (!this.$v.editedItemData.volume_month_min.$dirty) return errors;
      if (!this.$v.editedItemData.volume_month_min.required) {
        errors.push('This field is required');
      }
      if (!this.$v.editedItemData.volume_month_min.numeric) {
        errors.push('Must be numeric');
      }
      if (!this.$v.editedItemData.volume_month_min.isUnique) {
        if (this.errorValidation.volume_month_min != null) {
          this.errorValidation.volume_month_min.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    volumeMonthMaxErrors() {
      const errors = [];
      if (!this.$v.editedItemData.volume_month_max.$dirty) return errors;
      if (!this.$v.editedItemData.volume_month_max.required) {
        errors.push('This field is required');
      }
      if (!this.$v.editedItemData.volume_month_max.numeric) {
        errors.push('Must be numeric');
      }
      if (!this.$v.editedItemData.volume_month_max.isUnique) {
        if (this.errorValidation.volume_month_max != null) {
          this.errorValidation.volume_month_max.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    feeSharingErrors() {
      const errors = [];
      if (!this.$v.editedItemData.fee_sharing.$dirty) return errors;
      if (!this.$v.editedItemData.fee_sharing.required) {
        errors.push('This field is required');
      }
      if (!this.$v.editedItemData.fee_sharing.numericDecimal) {
        errors.push('Must be numeric');
      }
      if (!this.$v.editedItemData.fee_sharing.isUnique) {
        if (this.errorValidation.fee_sharing != null) {
          this.errorValidation.fee_sharing.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    startedDateValErrors() {
      const errors = [];
      if (!this.$v.editedItemData.started_date_val.$dirty) return errors;
      if (!this.$v.editedItemData.started_date_val.required) {
        errors.push('This field is required');
      }
      return errors;
    },
    volumeStatusErrors() {
      const errors = [];
      if (!this.$v.editedItemData.volume_status.$dirty) return errors;
      if (!this.$v.editedItemData.volume_status.isUnique) {
        if (this.errorValidation.volume_status != null) {
          this.errorValidation.volume_status.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    showMax: {
      get() {
        return !this.editedItemData.volume_status;
      },
      set() {
        const show = !this.editedItemData.volume_status;
        this.showMax = show;
      },
    },
  },
  watch: {
    dialogFee(val) {
      if (!val) this.cancelDialog();
    },
    'editedItemData.fee_name': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.fee_name != null &&
            val != this.errorValidation.fee_name
          ) {
            this.$store.commit(
              'settingFee/settingSpeFee/clearErrorVariable',
              'fee_name'
            );
          }
        }
      },
    },
    'editedItemData.volume_month_min': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.volume_month_min != null &&
            val != this.errorValidation.volume_month_min
          ) {
            this.$store.commit(
              'settingFee/settingSpeFee/clearErrorVariable',
              'volume_month_min'
            );
          }
        }
      },
    },
    'editedItemData.volume_month_max': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.volume_month_max != null &&
            val != this.errorValidation.volume_month_max
          ) {
            this.$store.commit(
              'settingFee/settingSpeFee/clearErrorVariable',
              'volume_month_max'
            );
          }
        }
      },
    },
    'editedItemData.fee_sharing': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.fee_sharing != null &&
            val != this.errorValidation.fee_sharing
          ) {
            this.$store.commit(
              'settingFee/settingSpeFee/clearErrorVariable',
              'fee_sharing'
            );
          }
        }
      },
    },
    'editedItemData.started_date_val': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.started_date_val != null &&
            val != this.errorValidation.started_date_val
          ) {
            this.$store.commit(
              'settingFee/settingSpeFee/clearErrorVariable',
              'started_date_val'
            );
          }
        }
      },
    },
    'editedItemData.volume_status': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.volume_status != null &&
            val != this.errorValidation.volume_status
          ) {
            this.$store.commit(
              'settingFee/settingSpeFee/clearErrorVariable',
              'volume_status'
            );
          }
        }
      },
    },
  },
  methods: {
    cancelDialog() {
      this.resetUniqueValidation();
      this.$emit('closeCancelParent');
    },
    resetUniqueValidation() {
      this.$store.commit('settingFee/settingSpeFee/clearErrors');
    },
    async save() {
      this.$store.commit('settingFee/settingSpeFee/setFlashErrorMessage', '');
      this.resetUniqueValidation();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const value = this.editedItemData;

        const dateItem = this.editedItemData.started_date_val.split('-');
        [value.start_year, value.start_month] = dateItem;

        if (this.editedIndex > -1) {
          await this.$store
            .dispatch('settingFee/settingSpeFee/updateData', {
              date,
              value,
              index: this.editedIndex,
            })
            .then((status) => {
              if (status) {
                this.cancelDialog();
                showAlert(
                  this.$store,
                  'Update setting SPE fee success !',
                  'mdi-check-circle',
                  'green'
                );
              } else {
                showAlert(
                  this.$store,
                  'Error on update setting SPE fee !',
                  'mdi-alert',
                  'red'
                );
              }
            });
        } else {
          await this.$store
            .dispatch('settingFee/settingSpeFee/createData', {
              date,
              value,
            })
            .then((status) => {
              if (status) {
                this.cancelDialog();
                showAlert(
                  this.$store,
                  'Add setting SPE fee success !',
                  'mdi-check-circle',
                  'green'
                );
              } else {
                showAlert(
                  this.$store,
                  'Error on Add setting SPE fee !',
                  'mdi-alert',
                  'red'
                );
              }
            });
        }
      }
    },

    isEmpty,
  },
};
</script>
